<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body wizard-content">
                        <h4 class="card-title">New Offer</h4>
                        <h6 class="card-subtitle"></h6>
                        <form class="tab-wizard vertical wizard-circle m-t-40 wizard clearfix" role="application" id="steps-uid-6">
                            <div class="steps clearfix">
                                <ul role="tablist">
                                    <li role="tab" v-for="step of steps" :key="step.id" :step="step" :currentstep="currentstep"
                                        :class="{'current': currentstep === step.id, 'done': step.completed === true}" aria-disabled="false" aria-selected="true">
                                        <a id="steps-uid-6-t-0" :href="step.path_name" aria-controls="steps-uid-6-p-0">
                                            <span class="step" v-text="step.id +1"></span> {{step.title}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="content clearfix">
                                <!-- Steps -->
                                <h4 class="m-b-20">{{steps[currentstep].title}}</h4>
                                <hr>
                                <router-view ref="child"></router-view>
                            </div>
                            <div class="actions clearfix">
                                <ul role="menu" aria-label="Pagination">
                                    <li class="disabled" aria-disabled="true">
                                        <button type="button" class="btn btn-secondary" @click="lastStep" :disabled="firststep">
                                            Back
                                        </button>
                                    </li>
                                    <li aria-hidden="false" aria-disabled="false">
                                        <button type="button" class="btn btn-success" v-if="!laststep" @click="nextStep" :disabled="laststep">
                                            Next
                                        </button>
                                    </li>
                                    <li aria-hidden="true" v-if="laststep">
                                        <button type="button" class="btn btn-success" v-if="laststep" @click="submitOffer">
                                            <i class="fa fa-save m-r-5"></i> Submit
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "AllOffers",
        data() {
            return {
                currentstep: 0,
                priceUnit: null,
                offer: {
                    type: null,
                    category: null,
                    contract_type: null,
                    expires_at: null,
                    maturation_date: null,
                },
                commodity: {
                    commodity: null,
                    grade: null,
                    special_quality: [],
                    year: null,
                    audit: null,
                    code: null,
                    variety: null
                },
                commodityIds: [],
                logistics: {
                    freight: null,
                    location: {
                        address: {
                            line1: null,
                            line2: null,
                            city: null,
                            state: null,
                            postal_code: null,
                            country: null
                        },
                        type: "BUSINESS",
                        location_props: {}
                    },
                    storage: null,
                    year: null,
                    period: null
                },
                pricing: {
                    currency: null,
                    unit: null,
                    price: 0,
                    quantity: 0,
                    type: ""
                },
                specification: {
                    documents: []
                },
                steps: [
                    {
                        id: 0,
                        title: "Offer Type",
                        icon_class: "fas fa-sign",
                        path_name: "step1",
                        completed: false,
                    },
                    {
                        id: 1,
                        title: "Commodity",
                        icon_class: "fas fa-box-open",
                        path_name: "step2",
                        completed: false
                    },
                    {
                        id: 2,
                        title: "Movement",
                        icon_class: "fas fa-truck-moving",
                        path_name: "step3",
                        completed: false
                    },
                    {
                        id: 3,
                        title: "Pricing",
                        icon_class: "fas fa-dollar-sign",
                        path_name: "step4",
                        completed: false
                    },
                    {
                        id: 4,
                        title: "Specification",
                        icon_class: "fas fa-ruler-combined",
                        path_name: "step5",
                        completed: false
                    },
                    {
                        id: 5,
                        title: "Summary",
                        icon_class: "fas fa-edit",
                        path_name: "summary"
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),
            active() {
                return this.step.id === this.currentstep;
            },
            firststep() {
                return this.currentstep === 0;
            },
            laststep() {
                return this.currentstep === this.steps.length - 1;
            }
        },
        beforeMount() {
            if(this.currentstep === 0) {
                this.$router.push(this.steps[0].path_name);
            }
            this.setYears();
        },
        methods: {
            async nextStep() {
                if(this.currentstep === 4) {
                    this.steps[this.currentstep].completed = true;
                    this.currentstep                       = this.currentstep + 1;
                    await this.$router.push(this.steps[this.currentstep].path_name);
                } else {
                    let valid = await this.$refs.child.validate();
                    if(valid) {
                        this.steps[this.currentstep].completed = true;
                        this.currentstep                       = this.currentstep + 1;
                        await this.$router.push(this.steps[this.currentstep].path_name);
                    }
                }
            },
            lastStep() {
                this.steps[this.currentstep].completed = false;
                this.currentstep                       = this.currentstep - 1;
                this.$router.push(this.steps[this.currentstep].path_name);
            },
            setYears() {
                let d      = new Date();
                let n      = d.getFullYear();
                this.years = [];
                this.years = [n, n + 1, n + 2, n + 3, n + 4];
            },
            async submitOffer() {
                let params = {
                    offer: this.offer,
                    commodity: this.commodity,
                    logistics: this.logistics,
                    pricing: this.pricing,
                    specification: this.specification
                };
                try {
                    await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/offers`, params);
                    this.$toastr('success', 'Offer added successfully', 'Offer Added');
                    await this.$router.push({name: "myoffers", params: {marketplaceid: this.currentOrg.marketplace_id}});
                } catch(e) {
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>

</style>
